const state = {
  reportStartDate: null,
  reportEndDate: null,
  dateSelectionMode: 'single',
  selectedPanel: null,
};

const mutations = {
  Set_reportStartDate(state, date) {
    state.reportStartDate = date;
  },
  Set_reportEndDate(state, date) {
    state.reportEndDate = date;
  },
  Set_dateSelectionMode(state, mode) {
    state.dateSelectionMode = mode;
  },
  Set_selectedPanel(state, panel) {
    state.selectedPanel = panel;
  },
};

const actions = {
  setReportStartDate({ commit }, date) {
    commit('Set_reportStartDate', date);
  },
  setReportEndDate({ commit }, date) {
    commit('Set_reportEndDate', date);
  },
  setReportDateSelectionMode({ commit }, mode) {
    commit('Set_dateSelectionMode', mode);
  },
  setSelectedPanel({ commit }, panel) {
    commit('Set_selectedPanel', panel);
  },
};

const getters = {
  reportStartDate: (state) => {
    return state.reportStartDate;
  },
  reportEndDate: (state) => {
    return state.reportEndDate;
  },
  reportDateSelectionMode: (state) => {
    return state.dateSelectionMode;
  },
  selectedPanel: (state) => {
    return state.selectedPanel;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
